import clsx from "clsx";
import treeLogo from "../assets/images/tree_logo.svg";
import t from "../locales";

const Footer = ({ nonStick }) => {
  return (
    <footer className={clsx("footer", nonStick && "footer--nonstick")}>
      <img className="footer__logo" src={treeLogo} alt={t("footer.label")} />
    </footer>
  );
};

export default Footer;
